var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserAdd = function SvgUserAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12H4v-1a1 1 0 0 0-2 0v1H1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2Zm4-4a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm7 7a7.03 7.03 0 0 0-.033-.644 7.111 7.111 0 0 0-.105-.734l-.007-.035a6.948 6.948 0 0 0-.166-.646l-.014-.043a7.036 7.036 0 0 0-3.435-4.097A4.988 4.988 0 0 0 14 5c0-2.757-2.243-5-5-5S4 2.243 4 5c0 1.524.688 2.889 1.766 3.806a7.394 7.394 0 0 0-.519.299l-.074.045a1 1 0 0 0 .576 1.815c.215 0 .411-.07.574-.184l.007-.004.016-.01c.186-.115.378-.22.58-.313l.014-.006a4.947 4.947 0 0 1 1.305-.385l.058-.009A5 5 0 0 1 14 15.004a1 1 0 0 0 2 0V15Z"
  })));
};
export default SvgUserAdd;